import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonCol, IonLabel, IonRow, IonText } from '@ionic/angular/standalone';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.component';

@Component({
  selector: 'app-accesorial-card',
  imports: [IonRow, IonLabel, IonText, IonCol, NgClass],
  templateUrl: './accesorial-card.component.html',
  styleUrl: './accesorial-card.component.scss',
})
export class AccesorialCardComponent {
  @Input() title!: string | null;
  @Input() hasSeperator = true;
  @Input() size!: number;
  @Input() data!: IOption[];
}
